import { Chart, ChartType, Plugin, Scale } from "chart.js";
import { AxisLabelDrawCallbackOptions } from "./axis-label-draw-callback.options";
import { BarChartAxisLabelData } from "./model";

class AxisLabelDrawCallbackPlugin<T extends ChartType = ChartType, O = Record<string, unknown>> implements Plugin<T, O> {
  id: string = 'axisLabelDrawCallbackPlugin';

  private defaultConfig: AxisLabelDrawCallbackOptions = {
    onYDrawCallback: (data: BarChartAxisLabelData[]) => {},
    onXDrawCallback: (data: BarChartAxisLabelData[]) => {}
  }

  afterDraw({scales: {x, y}}: Chart, args: Record<string, never>, options: O): boolean | void {
    const opt: AxisLabelDrawCallbackOptions = {...this.defaultConfig, ...options};

    opt.onYDrawCallback(this.collectData(y, true));
    opt.onXDrawCallback(this.collectData(x, false));
  }

  private collectData(scale: Scale, isYScale: boolean): BarChartAxisLabelData[] {
    return scale.ticks.map((value, index) => {
      let pixelForTick = scale.getPixelForTick(index);
      let valueForPixel = scale.getValueForPixel(pixelForTick);

      let data: any = isYScale ?  {
        x: 0,
        y: pixelForTick,
      } : {
        x: pixelForTick,
        y: scale.bottom + 10,
      };

      return {
        ...data,
        value: valueForPixel,
        label: scale.getLabelForValue(valueForPixel)
      }
    });
  }
}

export const axisLabelDrawCallbackPlugin: Plugin = new AxisLabelDrawCallbackPlugin();
